import { CircularProgress } from "@mui/material";
import { Box } from "@mui/system";

const CircularLoader = ({ label = null }) => {
  return (
    <Box
      sx={{
        width: '100%',
        height: label === 'NCRDetails' ? '100vh' : '350px',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center'
      }}
    >
      <CircularProgress />
    </Box>
  );
};

export default CircularLoader;
